import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import MediaQuery from 'react-responsive';
// nodejs library that concatenates classes
import classNames from "classnames";
// path constants
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import CustomHeader from "@app/components/Header/CustomHeader";
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Parallax from "@app/components/Parallax/Parallax";
import CustomHelmet from "@app/components/CustomHelmets/CustomHelmet";

import * as paths from '@app/constants/paths';
import * as plans from '@app/constants/plans';
// Sections
import SectionPricing from "@app/views/PricingPages/Sections/SectionPricing";
 
// styles
import landingPageStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageStyle";
// images
import termsOfUse720w from "@app/assets/img/bg/terms-of-use-agreement-500w.webp";
import termsOfUse1280w from "@app/assets/img/bg/terms-of-use-agreement-1000w.webp";
import termsOfUse1920w from "@app/assets/img/bg/terms-of-use-agreement-2000w.webp";
import termsOfUse2560w from "@app/assets/img/bg/terms-of-use-agreement-3000w.webp";

class LandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openConsumerModal: false,
            openProviderModal: false,
        };

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;                    
    }

    handleOpenModal(modalType) {
        this.setState({
            [modalType]: true
        });
    }
    handleCloseModal(modalType) {
        this.setState({
            [modalType]: false
        });
    }
    

    render() {
        const { classes } = this.props;

        const appName = this.props.intl.formatMessage({ id: "app.name" });
        const helmetTitle = this.props.intl.formatMessage({ id: "helmet.title" });
        const metaDescription = this.props.intl.formatMessage({ id: "meta.description" });
        const msTileColor = this.props.intl.formatMessage({ id: "meta.msTileColor" });
        const themeColor = this.props.intl.formatMessage({ id: "meta.themeColor" });
        const twitterCardType = this.props.intl.formatMessage({ id: "meta.twitterCardType" });
        const twitterSite = this.props.intl.formatMessage({ id: "meta.twitterSite" });
        const twitterCreator = this.props.intl.formatMessage({ id: "meta.twitterCreator" });
        const twitterDescription = this.props.intl.formatMessage({ id: "meta.twitterDescription" });
        const twitterTitle = this.props.intl.formatMessage({ id: "meta.twitterTitle" });
        const twitterImage = this.props.intl.formatMessage({ id: "meta.twitterImage" });
        const twitterImageAlt = this.props.intl.formatMessage({ id: "meta.twitterImageAlt" });
        const ogType = this.props.intl.formatMessage({ id: "og.type" });
        const ogSiteName = this.props.intl.formatMessage({ id: "og.site.name" });
        const ogTitle = this.props.intl.formatMessage({ id: "og.title" });
        const ogDescription = this.props.intl.formatMessage({ id: "og.description" });
        const ogImage = this.props.intl.formatMessage({ id: "og.image" });

        const customerHeader = this.props.intl.formatMessage({ id: "free.for.customers" });
        const proHeader = this.props.intl.formatMessage({ id: "choose.a.plan.to.get.started" });

        const userFree = window.location.pathname.startsWith('/pricing-professional') ? false : true;

        const header = userFree ? customerHeader : proHeader;

        const loggedIn = this.props.userProfile? true : false;

        const parallaxContent = (
            <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem
                md={8}
                sm={8}
                className={classNames(
                    classes.mlAuto,
                    classes.mrAuto,
                    classes.textCenter
                )}
              >
                <h1 className={classes.title}>
                    {header}
                </h1>
              </GridItem>
            </GridContainer>
          </div>
        );

        const main = (
            <div className={classNames(classes.main)}>
                <SectionPricing
                    free={userFree}
                    member={loggedIn}
                />
            </div>
        );

        return (
            <div>
                <CustomHelmet
                    helmetTitle={helmetTitle}
                    metaDescription={metaDescription}
                    msTileColor={msTileColor}
                    themeColor={themeColor}
                    twitterCardType={twitterCardType}
                    twitterSite={twitterSite}
                    twitterCreator={twitterCreator}
                    twitterDescription={twitterDescription}
                    twitterTitle={twitterTitle}
                    twitterImage={twitterImage}
                    twitterImageAlt={twitterImageAlt}
                    ogType={ogType}
                    ogSiteName={ogSiteName}
                    ogTitle={ogTitle}
                    ogDescription={ogDescription}
                    ogImage={ogImage}
                />
                <CustomHeader
                    brandName={appName}
                />
                <MediaQuery query="(max-device-width: 720px)">
                    <Parallax small
                        image={termsOfUse720w} 
                        filter="dark">
                            {parallaxContent}
                        </Parallax>
                </MediaQuery>
                <MediaQuery query="(min-device-width: 721px) and (max-device-width: 1280px)">
                    <Parallax small
                        image={termsOfUse1280w}
                        filter="dark">
                            {parallaxContent}
                        </Parallax>
                </MediaQuery>
                <MediaQuery query="(min-device-width: 1281px) and (max-device-width: 1920px)">
                    <Parallax small
                        image={termsOfUse1920w}
                        filter="dark">
                            {parallaxContent}
                        </Parallax>
                </MediaQuery>
                <MediaQuery query="(min-device-width: 1921px)">
                    <Parallax small
                        image={termsOfUse2560w}
                        filter="dark">
                            {parallaxContent}
                        </Parallax>
                </MediaQuery>
                {main}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        userProfile: state.authentication.userProfile
    }
}

export default connect(mapStateToProps)(injectIntl(withStyles(landingPageStyle)(LandingPage)));